registerComponent("sections/wa-como-usar", function (component) {
/**
 * sections/wa-como-usar — "Como usar / O Assistente ASA?".
 *
 * Sem comportamento: o QR é uma imagem e o resto é texto. Aqui fica só a
 * entrada das peças (`.entrada`, `_entrada.less` / ADR 0051).
 *
 * @param {HTMLElement} component - elemento raiz do componente
 * @param {Object} params
 */

if (Asa.movimentoPermitido()) {
    Asa.armarEntrada([component], '.entrada');
}

});
